
/**
 * Component: Licencias
 * Package: Licencias
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\admin\licencias\Licencias.js
 *
 * Requisito funcional: RQ10-007
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una tabla que permite listar las licencas y un modal para poder editarlas.
 */

import React, { Component } from 'react'
import SimpleModalPage from '../../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import ListadoPage from '../../../containers/page/ListadoPage'
import FiltrosLicenciasPage from '../../../containers/admin/licencias/FiltrosLicenciasPage'
import ModalLicenciasPage from '../../../containers/admin/licencias/ModalLicenciasPage'

class Licencias extends Component {
  componentDidMount () {
    this.props.actions.fetchLicencias()
  }

  render () {
    const {
      list = [], t,
      actions: {abrirModalLicencias, onDeleteLicencia}
    } = this.props

    const tKey = 'LICENCIAS.'
    const idElemento = 'idLicencia'
    const table = {
      id: 'licenciaTable',
      multiHeader: false,
      hasCheckbox: false,
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => abrirModalLicencias(row.idLicencia),
      mostrarDuplicar: false,
      mostrarEliminar: true,
      onDelete: (row) => onDeleteLicencia(row.idLicencia),
      mostrarCambioEstado: false,
      columns: [
        {id: 'id', name: 'Id'},
        {id: 'nombre', name: t(tKey + 'COLUMNS.NOMBRE')},
        {id: 'codLicencia', name: t(tKey + 'COLUMNS.COD_LICENCIA')},
        {id: 'modalidad', name: t(tKey + 'COLUMNS.MODALIDAD')},
        {id: 'fechaAlta', name: t(tKey + 'COLUMNS.FECHA_ALTA'), type: 'fecha'},
        {id: 'baja', name: t(tKey + 'COLUMNS.BAJA')},
        {id: 'version', name: 'Version'},
        {id: 'customizations', name: 'Customizaciones'},
        //{id: 'fechaBaja', name: t(tKey + 'COLUMNS.FECHA_BAJA'), type: 'fecha'},
        //{id: 'motivoBaja', name: t(tKey + 'COLUMNS.MOTIVO_BAJA')},
        {id: 'observaciones', name: t(tKey + 'COLUMNS.OBSERVACIONES')},
        {id: 'fechaExpiracion', name: t(tKey + 'COLUMNS.FECHA_EXPIRACION'), type: 'fecha'}
      ],
      rows: list,
      filtros: <FiltrosLicenciasPage />,
      initialValues: {}
    }

    return (
      <div>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ModalLicenciasPage/>
        <ListadoPage t_key={tKey} table={table}>
        </ListadoPage>
      </div>
    )
  }
}

export default Licencias
